import { render } from "./FooterPL.vue?vue&type=template&id=3ff683e1&scoped=true"
import script from "./FooterPL.vue?vue&type=script&lang=js"
export * from "./FooterPL.vue?vue&type=script&lang=js"

import "./FooterPL.vue?vue&type=style&index=0&id=3ff683e1&scoped=true&lang=css"

import exportComponent from "D:\\dev\\DiagDev-clean\\Projets autres\\AdminWSInterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ff683e1"]])

export default __exports__